import React, { Component } from 'react';
import _ from 'lodash';
import Fuse from 'fuse.js';

import CheckingParkingTable from '../components/CheckingParkingTable';
import CheckingParkingModel from '../components/CheckingParkingModel';
import ParkinglocationSelect from '../components/ParkinglocationSelect';

import { Layout, Button, Row, Col, Input, Icon, DatePicker, message } from 'antd';

class CheckingParkingScreen extends Component {

  fuseOptions = {
    shouldSort: true,
    includeScore: true,
    threshold: 0.1,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: [
      "plate"
    ]
  }

  state = {
    dataLoading: false,
    dataAll: [],
    data: [],
    parkinglocationFormModalVisible: false,
    parkinglocation: null,
    date: null,
  }

  loadData(parkinglocation, date = null) {
    if (parkinglocation) {
      this.setState({
        dataLoading: true
      });
      CheckingParkingModel.getByParkinglocation(parkinglocation, date)
        .then(data => {
          this.setState({
            dataLoading: false,
            dataAll: data,
            data: data,
          });
        })
        .catch(err => {
          message.warning('Pakovací oprávnění se nepodařilo načíst!');
          this.setState({
            dataLoading: false,
          });
        });
    } else {
      message.warning('Zvolte prosím lokalitu!');
    }
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      dataLoading: true
    })
    if (searchText) {
      let fuse = new Fuse(dataAll, this.fuseOptions);
      let results = fuse.search(searchText);
      results = results.map((result) => {
        return result.item;
      });
      this.setState({
        dataLoading: false,
        data: results
      });
    } else {
      this.setState({
        dataLoading: false,
        data: dataAll
      });
    }
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Kontrola PO - Seznam PO</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={22}>
                <ParkinglocationSelect
                  onChange={(value) => {
                    this.setState({ parkinglocation: value });
                    this.loadData(value, this.state.date);
                  }}
                  style={{ width: 300 }} />
                {' '}
                <DatePicker
                  defaultValue={this.state.date}
                  placeholder={"Zvolte datum a čas kontroly"}                
                  format={"DD.MM.YYYY HH:mm"}
                  showTime={{ format: 'HH:mm' }}
                  onOk={(date) => {
                    this.setState({ date: date });
                    this.loadData(this.state.parkinglocation, date);
                  }}
                  onChange={(date) => {
                    if (date === null) {
                      this.setState({ date: date });
                      this.loadData(this.state.parkinglocation, date);
                    }
                  }}
                  showToday={false}
                  allowClear={true}
                  style={{ width: 300 }} />
                {' '}
                <Input.Search
                  placeholder="Hledat RZ"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={2} offset={0} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData(this.state.parkinglocation, this.state.date) }} style={{ marginRight: 10 }}>
                  <Icon type="sync" />
                </Button>
              </Col>
            </Row>
          </div>
          <CheckingParkingTable
            data={this.state.data}
            loading={this.state.dataLoading}
            rowKey="plate"
          />
          <p style={{ fontSize: 12, fontStyle: 'italic' }}>PA - Platební automat, MPA - Mobilní platební aplikace, EPO - Evidence parkovacích oprávnění</p>
        </div>
      </Layout.Content>
    );
  }
}

export default CheckingParkingScreen;



// WEBPACK FOOTER //
// ./src/screens/CheckingParkingScreen.js